<template>
    <b-modal ref="auditFiles" id="auditFiles" size="sm" @show="onShow" ok-only :title="$t('Documents')">
        <template v-if="files.length">
            <b-row v-for="file in files" v-bind:key="file.document_id" align-h="start" no-gutters>
                <span @click="downloadFile(file.fileUrl)" class="fileUpload">{{file.filename}}</span>
                <hr/>
            </b-row>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'files',
    data() {
        return {
            files: []
        };
    },
    methods: {
        onShow(){
            this.files = this.$store.state.modal.payload.files;
        }
    }
};
</script>

<style scoped lang="scss">
.fileUpload{
    color: blueviolet;
}
.fileUpload:hover,
.fileUpload:focus {
    cursor: pointer;
    text-decoration: underline;
}
</style>
<i18n src="../../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/components/modals/AuditFiles.vue